export default "__VITE_ASSET__DaD8vJSX__"